import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';
import Button from '../../components/ui/Button';
import * as FiIcons from 'react-icons/fi';

const { FiMail, FiMapPin, FiCoffee, FiPhone } = FiIcons;

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: 'Order question',
    message: ''
  });

  const handleSubmit = (event) => {
    event.preventDefault();
    const { name, email, subject, message } = formData;
    const mailtoSubject = encodeURIComponent(`${subject} - ${name}`);
    const mailtoBody = encodeURIComponent(`From: ${name} (${email})\n\nMessage:\n${message}`);
    window.location.href = `mailto:hello@ubeafoods.com?subject=${mailtoSubject}&body=${mailtoBody}`;
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((previous) => ({ ...previous, [name]: value }));
  };

  return (
    <div className="bg-white min-h-screen font-sans">
      <section className="bg-sand py-20 border-b border-sand-dark/10">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 text-center">
          <h1 className="font-serif text-5xl md:text-6xl text-gray-900 mb-6">Get in Touch</h1>
          <p className="text-gray-700 text-lg md:text-xl leading-relaxed">
            Questions about our ube powder, wholesale pricing, or an order? We read everything and reply within 1–2 business days.
          </p>
        </div>
      </section>
      <section className="py-24 max-w-3xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 gap-16">
          <div className="bg-sand-light rounded-[2.5rem] p-8 md:p-12 border border-sand shadow-sm">
            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label htmlFor="name" className="block text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-2">Name</label>
                  <input required type="text" id="name" name="name" value={formData.name} onChange={handleChange} placeholder="Your name" className="w-full bg-white border-transparent rounded-xl px-4 py-3 focus:ring-2 focus:ring-ube outline-none transition-all" />
                </div>
                <div>
                  <label htmlFor="email" className="block text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-2">Email Address</label>
                  <input required type="email" id="email" name="email" value={formData.email} onChange={handleChange} placeholder="hello@example.com" className="w-full bg-white border-transparent rounded-xl px-4 py-3 focus:ring-2 focus:ring-ube outline-none transition-all" />
                </div>
              </div>
              <div>
                <label htmlFor="subject" className="block text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-2">Subject</label>
                <div className="relative">
                  <select id="subject" name="subject" value={formData.subject} onChange={handleChange} className="w-full bg-white border-transparent rounded-xl px-4 py-3 focus:ring-2 focus:ring-ube outline-none appearance-none cursor-pointer transition-all">
                    <option value="Order question">Order question</option>
                    <option value="Wholesale & cafés">Wholesale & cafés</option>
                    <option value="Press & partnerships">Press & partnerships</option>
                    <option value="Something else">Something else</option>
                  </select>
                  <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none text-gray-400">
                    <SafeIcon name="ChevronDown" className="w-4 h-4" />
                  </div>
                </div>
              </div>
              <div>
                <label htmlFor="message" className="block text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-2">Message</label>
                <textarea required id="message" name="message" value={formData.message} onChange={handleChange} rows="6" placeholder="How can we help you?" className="w-full bg-white border-transparent rounded-xl px-4 py-3 focus:ring-2 focus:ring-ube outline-none transition-all resize-none"></textarea>
              </div>
              <Button type="submit" className="w-full py-4 text-lg">Send Message</Button>
            </form>
          </div>
          <div className="space-y-12">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="space-y-3">
                <div className="w-10 h-10 bg-lavender-light text-ube rounded-full flex items-center justify-center"><SafeIcon icon={FiMail} className="w-5 h-5" /></div>
                <h3 className="font-serif text-xl text-gray-900">Email Us</h3>
                <p className="text-gray-600 text-sm"><a href="mailto:hello@ubeafoods.com" className="hover:text-ube transition-colors font-medium">hello@ubeafoods.com</a></p>
              </div>
              <div className="space-y-3">
                <div className="w-10 h-10 bg-lavender-light text-ube rounded-full flex items-center justify-center"><SafeIcon icon={FiPhone} className="w-5 h-5" /></div>
                <h3 className="font-serif text-xl text-gray-900">Call Us</h3>
                <p className="text-gray-600 text-sm"><a href="tel:+16575028336" className="hover:text-ube transition-colors font-medium">+1 (657) 502-8336</a></p>
              </div>
              <div className="space-y-3">
                <div className="w-10 h-10 bg-lavender-light text-ube rounded-full flex items-center justify-center"><SafeIcon icon={FiMapPin} className="w-5 h-5" /></div>
                <h3 className="font-serif text-xl text-gray-900">Mailing Address</h3>
                <p className="text-gray-600 text-sm leading-relaxed">UBea by Stonecord LLC<br />18047 Beach Blvd #1802<br />Huntington Beach, CA 92648</p>
              </div>
              <div className="space-y-3">
                <div className="w-10 h-10 bg-lavender-light text-ube rounded-full flex items-center justify-center"><SafeIcon icon={FiCoffee} className="w-5 h-5" /></div>
                <h3 className="font-serif text-xl text-gray-900">Partnerships</h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Wholesale &amp; cafés: looking for 20 kg (44 lbs) bulk bags and trade pricing? Visit our{' '}
                  <Link to="/wholesale" className="text-ube font-bold hover:underline">Wholesale page</Link>.
                </p>
              </div>
              <div className="space-y-3">
                <div className="w-10 h-10 bg-lavender-light text-ube rounded-full flex items-center justify-center"><SafeIcon icon={FiMapPin} className="w-5 h-5" /></div>
                <h3 className="font-serif text-xl text-gray-900">Where we are</h3>
                <p className="text-gray-600 text-sm leading-relaxed italic">Grown and dried in the Philippines · shipped from Manila · arriving through the Port of Los Angeles, California.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;